import { Container } from '@cp/ds/src/components/container';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { Helmet } from 'react-helmet';
import { ReactAppRedirectError } from '@common/model/reactApp/error';
import { HttpStatusCode } from '@cp/utils/const/httpStatusCode';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { useStaticRouterContext } from '../../shared/context/staticRouterContext/context';

const RedirectPage: React.FC<{ error: ReactAppRedirectError }> = ({ error }) => {
  const staticRouterContext = useStaticRouterContext();
  const url = String(error.payload);

  if (staticRouterContext) {
    staticRouterContext.url = url;
    staticRouterContext.statusCode = HttpStatusCode.Found;
  }

  return (
    <div>
      <Helmet>
        <title>Переадресация...</title>
      </Helmet>
      <Container>
        <Stack my={{ xs: 4, md: 18 }}>
          <Typography sx={{ textAlign: 'center', mb: 4 }} variant="h4">
            Переадресация...
          </Typography>
          <Typography sx={{ textAlign: 'center' }} variant="body">
            Запрашиваемая Вами страница находится по адресу: <Link href={url}>{url}</Link>
          </Typography>
        </Stack>
      </Container>
    </div>
  );
};

export default RedirectPage;
